import { atom, selector } from "recoil";
import { UserDto } from "../module/global.types";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const auth_user = atom({
    key: "auth_user",
    default: {} as UserDto,
    effects_UNSTABLE: [persistAtom],
})

export const selectAuthUser = selector({
    key: 'auth_user_',
    get: ({ get }) => {
        const user = get(auth_user);
        return user
    },
});